'use client'

import { usePathname } from 'next/navigation'
import type { ReactNode } from 'react'

/**
 * Keeps an overlay (popups, floating reviews) off the page a buyer is paying
 * on. Decided here from the live pathname, not in the root layout: that
 * layout does not re-render on client navigation, so a server-side route check
 * holds only for a hard load and then sticks to the next page.
 */
export default function HiddenOnCheckout({ children }: { children: ReactNode }) {
  return usePathname() === '/checkout' ? null : <>{children}</>
}
